<template>
  <el-container class="app-body">
    <el-aside width="initial" class="app-aside">
      <div class="logo" :class="{ 'logo-collapse': isCollapse }">
        <span>{{ isCollapse ? shortName : name }}</span>
      </div>
      <div class="scroll-container">
        <el-menu
          :default-active="$route.path"
          active-text-color="#1f8fff"
          :collapse="isCollapse"
          router
        >
          <template v-for="(item, index) in menus">
            <el-menu-item
              v-if="!item.children || !item.children.length"
              :index="item.path"
              :key="index"
            >
              <i :class="item.meta.icon"></i>
              <span>{{ item.name }}</span>
            </el-menu-item>
            <el-submenu v-else :index="index.toString()" :key="index">
              <template slot="title">
                <i :class="item.meta.icon"></i>
                <span>{{ item.name }}</span>
              </template>
              <el-menu-item
                v-for="c in item.children"
                :index="c.path"
                :key="c.path"
              >
                <ruby></ruby>{{ c.name }}
              </el-menu-item>
            </el-submenu>
          </template>
        </el-menu>
      </div>
    </el-aside>
    <el-container>
      <el-header class="header-box" height="50px">
        <div>
          <i class="el-icon-menu switch" @click="handleCollapse"></i>
          <!--<span>{{ name }}</span>-->
        </div>
        <ul class="navbar-right">
          <!-- <li><i class="el-icon-search"></i></li>
                    <li>
                        <el-badge is-dot>
                            <i class="el-icon-message-solid"></i>
                        </el-badge>
                    </li> -->
          <li @click="handleJump">
            <el-button type="text">进入邮箱</el-button>
          </li>
          <li @click="handleRestart">
            <el-button type="text">重启服务</el-button>
          </li>
          <li>
            <i class="el-icon-user-solid"></i>
            <el-dropdown trigger="click" @command="handleCommand">
              <span class="el-dropdown-link">
                {{ user.account }}
                <i class="el-icon-caret-bottom"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item icon="el-icon-lock" command="cpwd"
                  >修改密码</el-dropdown-item
                >
                <el-dropdown-item icon="el-icon-switch-button" command="logout"
                  >退出系统</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </li>
        </ul>
        <!-- 修改密码 start-->
        <east-cpwd :visible.sync="isShow"></east-cpwd>
        <!-- 修改密码 end -->
      </el-header>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item
          v-for="item in $breadcrumb"
          :to="item.to"
          :key="item.level"
        >
          {{ item.title }}
        </el-breadcrumb-item>
      </el-breadcrumb>
      <el-main class="main-box">
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>
<script>
import ADMIN from "@/api/admin";
import { mapState } from "vuex";

export default {
  data() {
    return {
      menuConfig: null,
      name: "网易企业邮箱账户集成平台",
      shortName: "网易邮箱",
      isCollapse: window.localStorage.getItem("menu_collapse") === "true",
      isShow: false
    };
  },
  computed: {
    ...mapState(["user", "descriptors"]),
    // breadcrumb: vm => vm.$route.matched.filter(p => p.path !== ""),
    baseMenu: vm =>
      vm.$router.options.routes
        .find(p => p.path === "/")
        .children.filter(p => p.meta?.menu)
        .map(p => ({
          ...p,
          children: p.children?.filter(p => p.meta?.menu)
        })),
    dynamicMaillistMenu() {
      if (this.descriptors) {
        let dynamicMaillist = this.descriptors
          .filter(d => d.interfaceTypeName === "IDynamicMaillist")
          .map(d => ({
            name: d.friendlyName,
            path: `/plugin/${d.name}`
          }));
        if (dynamicMaillist.length) {
          return [
            {
              name: "扩展邮件列表",
              children: [
                ...dynamicMaillist,
                {
                  name: "结果预览",
                  path: "/maillist/preview"
                }
              ],
              meta: {
                icon: "el-icon-tickets"
              }
            }
          ];
        }
      }
      return [];
    },
    otherMenu() {
      if (this.descriptors) {
        let others = this.descriptors
          .filter(d => d.interfaceTypeName !== "IDynamicMaillist")
          .map(d => ({
            name: d.friendlyName,
            path: `/plugin/${d.name}`
          }));
        if (others.length) {
          return [
            {
              name: "扩展组件列表",
              children: others,
              meta: {
                icon: "el-icon-set-up"
              }
            }
          ];
        }
      }
      return [];
    },
    allMenus: vm => [
      ...vm.baseMenu,
      ...vm.dynamicMaillistMenu,
      ...vm.otherMenu
    ],
    menus() {
      if (this.menuConfig) {
        let menus = this.allMenus.filter(
          m => this.menuConfig[m.name] !== false
        );
        for (let subMenu of menus) {
          subMenu.children = subMenu.children?.filter(
            m => this.menuConfig[m.name] !== false
          );
        }
        return menus;
      }
      return [];
    }
  },
  components: { "east-cpwd": () => import("@/pages/main/components/cpwd") },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      let response = await ADMIN.MENU();
      if (response.data.state) {
        this.menuConfig = response.data.config;
      }
    },
    handleCollapse() {
      this.isCollapse = !this.isCollapse;
      window.localStorage.setItem("menu_collapse", this.isCollapse);
    },
    handleJump() {
      window.open(process.env.VUE_APP_BASE_API + "sync/home/emaillogin");
    },
    async handleRestart() {
      try {
        await this.$confirm("是否确定重启系统服务?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          lockScroll: false
        });
        let response = await ADMIN.STOP_APPLICATION();
        if (response.data.state) {
          await this.$message.success(
            "系统服务重启成功，如页面未更新可尝试手动刷新"
          );
        } else {
          await this.$message.error("系统服务重启失败");
        }
        // eslint-disable-next-line no-empty
      } catch {}
      // .then(() => {
      // 重启服务
      // putHost().then(res => {
      //   if (res.code === 0) {
      //     this.$notify.success({
      //       title: "成功",
      //       message: "成功重启系统服务",
      //       duration: 1500
      //     });
      //   } else {
      //     this.$notify.error({
      //       title: "失败",
      //       message: "重启系统服务失败",
      //       duration: 1500
      //     });
      //   }
      // });
      // })
      // .catch(() => {});
    },
    async handleCommand(command) {
      if (command === "cpwd") {
        this.isShow = true;
      } else if (command === "logout") {
        // 注销token
        try {
          await this.$confirm("是否确认退出系统?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            lockScroll: false
          });
          window.location = ADMIN.LOGOUT_URL;
          // eslint-disable-next-line no-empty
        } catch {}
      }
    }
  }
};
</script>
<style lang="less" scoped>
@sideWidth: 180px;
@sideWidthCollapsed: 68px;
@topFc: #ffffff;
@topBc: #006edb;
@topBcTrans: #0e82f5;
@topSpacer: #0354a5;

@asideFc: #3c3e52;
@asideBc: #ffffff;
@scrollBRc: #e7e6e6;
@asideAc: #1f8fff;
@asideABc: #f9fbfd;
.app-body {
  height: 100%;
  .app-aside {
    min-height: 0;
    display: flex;
    flex-direction: column;
  }
}
.ruby {
  ruby {
    display: inline-block;
    width: 6px;
    height: 6px;
    margin-right: 7px;
    border-radius: 50%;
    background-color: @asideFc;
  }
}
// 左侧导航区
.el-aside {
  background-color: @asideBc;
  text-align: left;
  .logo {
    width: 100%;
    height: 50px;
    display: flex;
    flex: none;
    align-items: center;
    justify-content: center;
    background-color: @topBc;

    span {
      display: inline-block;
      overflow: hidden;
      width: @sideWidth;
      white-space: nowrap;
      text-align: center;
      color: #ffffff;
      font-size: 14px;
      transition: width 0.3s linear;
    }
  }
  .logo-collapse {
    span {
      width: @sideWidthCollapsed;
      // display: none;
    }
  }
  .scroll-container {
    flex-grow: 1;
    min-height: 0;
    border-right: 1px solid @scrollBRc;
    overflow-x: hidden;
    overflow-y: auto;
  }
}

.el-menu {
  border: none;
  color: @asideFc;
  background-color: @asideBc;
  &:not(.el-menu--collapse) {
    width: @sideWidth;
    *:not(i) {
      font-size: 13px;
    }
  }
  .el-menu-item,
  .el-submenu {
    border-left: @asideBc 2px solid;
  }
  .el-menu-item,
  .el-submenu__title {
    color: @asideFc;
    background-color: @asideBc;
    &:hover {
      color: @asideAc;
      i {
        color: @asideAc;
      }
      ruby {
        background-color: @asideAc;
      }
    }
  }
  .is-active {
    border-left: @asideAc 2px solid;
    background-color: @asideABc;
    i,
    span {
      color: @asideAc;
    }
    .el-submenu__title,
    ul.el-menu--inline li {
      background-color: @asideABc;
      &.is-active {
        margin-top: 0px;
        ruby {
          background-color: @asideAc;
        }
      }
    }
  }
}
.el-menu--collapse {
  width: @sideWidthCollapsed;
  .el-menu-item i,
  .el-submenu i {
    font-size: 24px;
  }
}

.el-menu--popup {
  width: auto !important;
  min-width: 150px !important;
  margin-left: 0px;
  border-radius: 0 3px 3px 0;
  .el-menu-item {
    border-left: none;
    padding-left: 20px !important;
    height: 36px;
    line-height: 36px;
    .ruby();
  }
  li.is-active {
    ruby {
      background-color: @asideAc;
    }
  }
}
.el-menu--inline {
  width: auto !important;
  .el-menu-item {
    border-left: none;
    padding-left: 40px !important;
    height: 36px;
    line-height: 36px;
    .ruby();
  }
}

.header-box {
  background-color: @topBc;
  background-image: linear-gradient(to right, @topBc 0%, @topBcTrans 100%);
  background-repeat: repeat-x;
  color: @topFc;
  line-height: 50px;
  font-size: 13px;
  padding: 0px 5px;
  padding-left: 8px;
  overflow: hidden;
  box-sizing: initial;
  display: flex;
  justify-content: space-between;
  i {
    cursor: pointer;
    font-size: 16px;
    &.switch {
      position: relative;
      font-size: 16px;
      top: 1px;
      cursor: pointer;
      margin-right: 2px;
    }
  }

  ul.navbar-right {
    padding-right: 10px;
    line-height: 20px;
    display: flex;
    align-items: center;
    li {
      margin-left: 15px;
      list-style: none;
      font-size: 13px;
      .el-button {
        color: #ffffff;
      }
      .el-dropdown-link {
        color: #ffffff;
        cursor: pointer;
        font-size: 13px;
        position: relative;
        top: -1px;
      }
      // &:first-child::before {
      //     content: '|';
      //     color: @topSpacer;
      //     padding-right: 10px;
      // }
    }
  }
}
.el-dropdown-menu .el-dropdown-menu__item {
  font-size: 13px;
}
.el-breadcrumb {
  flex: none;
  z-index: 10;
  box-shadow: 0 0px 3px 0 rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  border-bottom: 1px solid @scrollBRc;
  color: #333333;
  text-align: left;
  padding: 0px 10px;
  height: 39px;
  line-height: 39px;
  font-size: 13px;
}
.main-box {
  display: flex;
  position: relative;
}
.el-main {
  padding: 0;
  background-color: #fffefe;
  font-size: 13px;
  overflow: hidden;
}
</style>
